import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import { keaSignIn } from 'actions/Auth';
import { Link } from 'react-router-dom';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import AuthShell from './AuthShell';
import styles from './AuthShell.module.scss';

const SignInPage = () => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { loader } = useSelector(({ auth }) => auth);

  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const submitLogin = (event) => {
    if (event) event.preventDefault();
    dispatch(keaSignIn({
      email: emailInputRef.current.value,
      password: passwordInputRef.current.value,
    }));
  };

  useEffect(() => {
    if (emailInputRef.current) emailInputRef.current.focus();
  }, []);

  return (
    <>
      <AuthShell
        title={localizeMessage('auth.signin.title')}
        description={localizeMessage('auth.signin.description')}
        loading={loader}
      >
        <form className={styles.form} onSubmit={submitLogin}>
          <TextField
            id="kea-signin-email"
            name="username"
            className={styles.field}
            label={localizeMessage('appModule.email')}
            type="email"
            autoComplete="username"
            fullWidth
            required
            variant="outlined"
            inputRef={emailInputRef}
            disabled={loader}
          />
          <TextField
            id="kea-signin-password"
            name="password"
            className={styles.field}
            type="password"
            label={localizeMessage('appModule.password')}
            autoComplete="current-password"
            fullWidth
            required
            variant="outlined"
            inputRef={passwordInputRef}
            disabled={loader}
          />
          <Button
            className={styles.primaryButton}
            type="submit"
            variant="contained"
            color="primary"
            disabled={loader}
          >
            <IntlMessages id="appModule.signIn" />
          </Button>
          <Link className={styles.secondaryLink} to="/signin/forgot-password">
            <IntlMessages id="appModule.forgotPassword" />
          </Link>
        </form>
      </AuthShell>
    </>
  );
};

export default SignInPage;
